/**
 * Garde « une seule fois par utilisateur, jusqu'à la prochaine déconnexion ».
 *
 * Supabase ré-émet SIGNED_IN à chaque retour de focus sur l'onglet, sans
 * nouvelle connexion. La migration guest→user appelle `claim_guest_polls`,
 * plafonnée à 10/heure/utilisateur côté base : sans ce garde, quelques
 * changements d'onglet épuisent le plafond et la RPC rend un 400
 * (`rate_limit_exceeded`, constaté sur /admin/pulse, #1277) — y compris au
 * vrai login suivant.
 */
export function createOncePerSignIn() {
  let doneFor: string | null = null;

  return {
    /** true la première fois pour cet utilisateur (et le marque), false ensuite. */
    shouldRun(userId: string): boolean {
      if (doneFor === userId) return false;
      doneFor = userId;
      return true;
    },
    /** À appeler sur SIGNED_OUT : la prochaine connexion doit de nouveau migrer. */
    reset(): void {
      doneFor = null;
    },
  };
}
